<template>
  <section>
    <!--intro section-->
    <!--background image snippets-->
    <div
      v-rellax="{ speed: -4 }"
      class="contact-left position-absolute d-none d-lg-block"
    >
      <img
        width="200px"
        src="../../assets/img/contact-left.png"
        alt=""
        class=""
      />
    </div>
    <div
      v-rellax="{ speed: -1 }"
      class="contact-right position-absolute d-none d-lg-block"
    >
      <img
        width="300px"
        src="../../assets/img/contact-right.png"
        alt=""
        class=""
      />
    </div>

    <div
      class="img-contact-right position-absolute d-none d-xl-block rounded-circle"
      :style="{ background: `url(${images.mainImg})` }"
    ></div>
    <div
      class="img-contact-left position-absolute d-none d-xl-block rounded-circle"
      :style="{ background: `url(${images.smImg})` }"
    >
      <!--<img width="200px" src="../../assets/img/contact-right.png" alt="" class="">-->
    </div>
    <div v-if="loaded">
      <div class="container">
        <div class="row">
          <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
            <h1
              class="page-title text-gradient mb-2"
              data-aos="fade-right"
              data-aos-easing="ease-in-out-quad"
              data-aos-once="true"
              data-aos-duration="1000"
            >
              {{ content.pageContent.title }}
            </h1>
            <h4
              class="text-gradient text-bold mb-5 f-23"
              data-aos="fade-right"
              data-aos-easing="ease-in-out-quad"
              data-aos-once="true"
              data-aos-delay="500"
              data-aos-duration="1000"
            >
              {{ content.pageContent.subtitle }}
            </h4>
            <div
              id=""
              class="d-flex justify-content-center my-5 animated bounce slower delay-1s w-100"
              style="z-index: 1"
            >
              <span
                class="section-nav bg-white shadow-sm pointer"
                @click="scrollToSection('scroll-down')"
                data-aos="fade-down"
                data-aos-duration="3000"
                data-aos-easing="ease-in-out-back"
                data-aos-offset="-500"
                data-aos-once="true"
              >
                <img src="../../assets/svg/arrow-down.svg" alt="" class="" />
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--END intro section-->

      <!--contact-us body-->
      <div
        id="scroll-down"
        class="row no-gutters position-relative h-auto co-info mt-n4"
      >
        <div class="col-12 text-center font-weight-bold f-20 p-2 p-md-0">
          <div
            class="text-lilac-light"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-duration="500"
          >
            Leicester Caribbean Community Caribbean Carnival CIO
          </div>
          <div
            class="text-white"
            data-aos="fade-up"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            African Caribbean Centre<br />
            Maidstone Road<br />
            Leicester LE2 0UA<br />
            <span
              class="underline pointer"
              @click="scrollToSection('map-section')"
              >View Map & Directions</span
            >
          </div>
          <div
            class="mt-3 text-white"
            data-aos="fade-up"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            <span class="text-lilac-light mr-1">Telephone:</span>0116 2211793<br />
            <span class="text-yellow mr-1">Email:</span>
            admin@leicestercarnival.co.uk
          </div>
          <div
            class="mt-4 text-white"
            data-aos="fade-up"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-duration="500"
          >
            <span class="text-yellow mr-1">Office Hours:</span
            >{{ content.officeHours.timeStart }} to
            {{ content.officeHours.timeEnd }}
            {{ content.officeHours.dayStart }} to
            {{ content.officeHours.dayEnd }}
          </div>
        </div>
        <div
          class="mt-5 col-12 col-md-8 offset-md-2 text-center p-2 p-md-0 f-14 position-relative"
          style="z-index: 8"
        >
          <div
            class="text-white"
            :class="{ 'mt-3': index !== 0 }"
            v-for="(direction, index) in content.directions"
            :key="`dir-${index}`"
          >
            <span class="font-weight-bold">{{
              direction.split(' ').slice(0, 3).join(' ')
            }}</span>
            {{ direction.split(' ').slice(4).join(' ') }}
          </div>
        </div>
        <div
          id="contact-form-section"
          class="col-12 p-2 p-md-0 mt-100 mb-80 position-relative"
          style="z-index: 8"
        >
          <div class="f-36 mesg-heading text-gradient text-center pb-4">
            {{ content.pageContent.contactFormTitle }}
          </div>
          <div class="m-auto contact-form p-3 p-sm-0">
            <b-form @submit.prevent="sendMessage()">
              <div class="form-row w-100">
                <div class="col">
                  <div class="form-group">
                    <input
                      class="form-control"
                      placeholder="Name"
                      v-model="form.name"
                      required
                    />
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <input
                      type="tel"
                      class="form-control"
                      placeholder="Tel"
                      v-model="form.phone"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="form-row w-100">
                <div class="col">
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Email"
                      v-model="form.email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="form-row w-100">
                <div class="col">
                  <div class="form-group">
                    <input
                      class="form-control"
                      placeholder="Your Message"
                      v-model="form.message"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="text-center">
                <b-button
                  type="submit"
                  class="px-5 btn-carnival bg-yellow text-blue font-weight-bold"
                >
                  <b-spinner
                    style="width: 17px; height: 17px"
                    v-if="sending"
                    small
                  ></b-spinner>
                  <span v-else> Send Message</span>
                </b-button>
              </div>
            </b-form>
          </div>
        </div>
        <!-- <div class="col-12 p-2 p-md-0 mt-100 mb-80">
                    <div class="d-flex flex-column justify-content-between c-action">
                        <div class="f-36 mesg-heading text-gradient text-center pb-5">{{content.pageContent.closing}}
                        </div>
                        <div class="d-flex justify-content-center flex-column flex-sm-row align-items-center">
                            <b-button
                                    @click="goToTicketList"
                                    class="py-2 btn-carnival bg-lilac text-white font-weight-bold mx-3 my-2 d-flex">
                                Book Tickets
                            </b-button>
                            <b-button
                                    @click="downloadFile(vendorRegFile.url)"
                                    class="py-2 btn-carnival bg-blue-50 text-white font-weight-bold mx-3 my-2  d-flex">
                                Vendor Registration
                            </b-button>
                            <b-button
                                    @click="scrollToSection('contact-form-section')"
                                    class="py-2 btn-carnival bg-green text-white font-weight-bold mx-3 my-2 d-flex">
                                Troupe Registration
                            </b-button>
                        </div>
                    </div>
                </div> -->
        <div class="map-title text-center mt-100 w-100">
          <p class="f-36 mesg-heading text-gradient text-center mb-2">
            {{ content.pageContent.mapTitle }}
          </p>
          <div class="text-white f-20 font-weight-bold">
            {{ content.pageContent.mapSubtitle }}
          </div>
        </div>
      </div>
      <!--END contact-us body-->

      <!--blue-background-->
      <!--<div class="w-100 bg-blue">-->
      <!--<div class="section-nav position-relative t-minus">-->
      <!--</div>-->
      <!--</div>-->
      <!--END blue-background-->

      <!--map-section-->
      <div
        class="map-section row no-gutters flex-column flex-sm-row"
        id="map-section"
      >
        <div
          class="col text-black px-4 pt-4 d-flex flex-column justify-content-center"
        >
          <h1
            class="text-gradient pl-md-custom2 font-weight-bold display-4 d-none d-md-block mb-2"
          >
            Carnival Route
          </h1>
          <h1
            class="text-gradient pl-md-custom2 font-weight-bold d-block d-md-none mb-2"
          >
            Carnival Route
          </h1>
          <ol class="pl-md-custom">
            <li
              v-for="(location, index) in locationList"
              :key="index"
              class="mb-2 carnival-route-item"
            >
              {{ location }}
            </li>
          </ol>
        </div>

        <div
          class="col fancy-map cover-bg pointer"
          @click="showZoomModal()"
        ></div>
      </div>
    </div>
    <div v-else>Loading Content</div>
    <!--END map-section-->
    <zoom-modal ref="map-zoom-container">
      <img
        :src="require('../../assets/img/pop-up-map.png')"
        class="map-img"
        slot="content"
      />
    </zoom-modal>
  </section>
</template>

<script>
import axios from 'axios';
import gmapsInit from '../../utils/gmaps';
import { dbRefs } from '../../services/firebase/init';
import EventMixin from '../../mixins/eventInfo';
import locationMarker from '../../assets/svg/location-marker-2.svg';
import { mapState } from 'vuex';

export default {
  data() {
    return {
      content: {},
      images: {},
      loaded: false,
      form: {
        name: '',
        email: '',
        phone: '',
        message: '',
      },
      vendorCategories: [
        { category: 'Food Stalls', price: 900 },
        { category: 'Arts and Crafts', price: 250 },
        { category: 'Promotional', price: 1500 },
      ],
      sendMailURL:
        'https://us-central1-media-beast.cloudfunctions.net/sendMail',
      sending: false,
      contentFetched: false,
      locationList: [
        'Opening Ceremony - Granville Road',
        'Victoria Park',
        'Granville Road',
        'London Road',
        'St. Georges Way',
        'Charles Street',
        'Humberstone Gate',
        'Gallowtree Gate',
        'Granby Street',
        'Northampton Street',
        'Charles Street',
        'London Road',
        'Granville Road',
        'Back to Victoria Park',
      ],
    };
  },

  mixins: [EventMixin],
  firestore: {
    content: dbRefs.contactRef,
    images: dbRefs.imgRef.doc('contact'),
  },
  computed: {
    addressSplit() {
      return this.content.contactInfo.strAddr.split(',');
    },
  },
  methods: {
    hideMapModal() {
      this.$refs['map-modal'].hide();
    },
    // async setMap1() {
    //   try {
    //     const google = await gmapsInit();
    //     const geocoder = new google.maps.Geocoder();
    //     const map = new google.maps.Map(this.$refs['mapBox'], { zoom: 16 });
    //     geocoder.geocode(
    //       {
    //         address: `${this.event.venue}, ${this.event.city}, ${this.event.postalCode}`,
    //       },
    //       (results, status) => {
    //         if (status !== 'OK' || !results[0]) {
    //           console.log('status not ok');
    //           throw new Error(status);
    //         }
    //         map.setCenter(results[0].geometry.location);
    //         const image = locationMarker;
    //         const marker = new google.maps.Marker({
    //           map,
    //           position: results[0].geometry.location,
    //           icon: image,
    //         });
    //       },
    //     );
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    async setMap1() {
      try {
        const google = await gmapsInit();
        const geocoder = new google.maps.Geocoder();
        const defaultLatLng = { lat: 52.6278, lng: -1.1215 };

        const map = new google.maps.Map(this.$refs['mapBox'], {
          center: defaultLatLng,
          zoom: 16,
        });

        const address =
          this.event && this.event.venue
            ? `${this.event.venue}, ${this.event.city}, ${this.event.postalCode}`
            : 'Granville Rd, Leicester LE1 7RY';

        geocoder.geocode({ address }, (results, status) => {
          if (status === 'OK' && results[0]) {
            map.setCenter(results[0].geometry.location);
            new google.maps.Marker({
              map,
              position: results[0].geometry.location,
              icon: require('../../assets/svg/location-marker-2.svg'),
            });
          } else {
            // Use default location if geocoding fails
            console.warn(
              'Geocoding failed or address is missing. Using default location.',
            );
            new google.maps.Marker({
              map,
              position: defaultLatLng,
              icon: require('../../assets/svg/location-marker-2.svg'),
            });
          }
        });
      } catch (e) {
        console.error('Google Maps initialization failed:', e);
      }
    },
    async sendMessage() {
      try {
        this.sending = !this.sending;
        const mesgResp = await axios.post(this.sendMailURL, { ...this.form });
        console.log(mesgResp, 'is emsgresp');
        this.$toasted.success('Your message is on its way!');
        Object.keys(this.form).forEach((key) => {
          this.form[key] = '';
        });
      } catch (e) {
        this.$toasted.error('Something went wrong. Please try again.');
      } finally {
        this.sending = !this.sending;
      }
    },
  },
  watch: {
    content: function (newValue, oldValue) {
      if (Object.keys(newValue).length > 0) {
        this.loaded = true;
      }
    },
  },
  async updated() {
    await this.setMap1();
  },
  mounted() {
    if (this.$route.query.regTroupe) {
      setTimeout(() => {
        this.scrollToSection('contact-form-section', 100);
      }, 1200);
    }
    if (this.$route.query.mapRoutes) {
      setTimeout(() => {
        this.scrollToSection('map-section');
      }, 1200);
    }
  },
};
</script>
<style lang="scss" scoped>
.co-info {
  background-color: #2b2e83;
  padding: 130px 0 40px;
}

.about-head {
  margin-top: 180px;
}

.mesg-heading {
  /*line-height: 0.75;*/
  letter-spacing: -0.4px;
  font-weight: bold;
}

.contact-form {
  width: 100%;
  max-width: 826px;
}

.form-row {
  margin-bottom: 25px;
}

.form-control {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid rgba(136, 139, 223, 0.28);
  border-radius: 0;
  padding: 0;
  font-size: 22px;
  color: white;
  line-height: 3.36;
  text-align: left;
  transition: border-bottom 0.5s;

  &::placeholder {
    font-size: 22px;
    line-height: 3.36;
    letter-spacing: -0.7px;
    text-align: left;
    color: rgba(136, 139, 223, 0.28);
  }
  &:hover {
    border-bottom: 1px solid $lilac;
  }

  &:focus {
    box-shadow: none;
    border-bottom: 1px solid $lilac;
  }
}

.c-action {
  text-align: center;
  height: auto;
  width: 100%;
  max-width: 826px;
  border-radius: 22.5px;
  padding: 58px;
  margin: auto;
  background-color: #252876;
  @media (max-width: 576px) {
    padding: 30px;
  }

  div .btn-carnival {
    width: 223px;
    text-align: center;
  }
}

.pl-md-custom {
  padding-left: 16px;
  @media (min-width: 768px) {
    padding-left: 70px;
  }
}

.pl-md-custom2 {
  padding-left: 0px;
  @media (min-width: 768px) {
    padding-left: 50px;
  }
}

.map-title {
  bottom: 0;
}

.map-section {
  height: 633px;
  .col {
    width: 100%;
    height: 633px;
  }
  .fancy-map {
    background-image: url('./../../assets/img/pop-up-map.png');
  }
}

.t-minus {
  top: 30px;
}

footer {
  padding-top: 0 !important;
}

.contact-left {
  top: 9%;
  z-index: 1;
}

.contact-right {
  right: 0;
  top: 25%;
  z-index: 1;
}

.btn {
  width: 220px;
  height: 45px;
}

.img-contact-right {
  right: 4%;
  top: 12.5%;
  /*background: url("../../assets/img/drummers.png");*/
  height: 407px;
  width: 407px;
  background-size: cover;
  z-index: 9;
  @media (max-width: 768px) {
    right: 3%;
    top: 9%;
    height: 200px;
    width: 200px;
  }
}

.img-contact-left {
  top: 12.5%;
  left: 15%;
  /*background: url("../../assets/img/pidgeon.png");*/
  height: 226px;
  width: 226px;
  background-size: cover;
  z-index: 9;
  @media (max-width: 768px) {
    top: 9%;
    left: 7%;
    height: 150px;
    width: 150px;
  }
}

#mapBox {
  height: auto;
}

.bg-map {
  height: auto;
}

.map-img {
  object-fit: contain;
  width: 100%;
  display: block;
  margin: auto;
  height: 646px;
}

.carnival-route-item {
  font-size: 1rem;
  @media (min-width: 768px) {
    font-size: 1.25rem;
    font-weight: 500;
  }
}
</style>
